// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2ATI4","vLegacy":"SelectSecondary_vLegacy__2yV77","error":"SelectSecondary_error__3m5Cj","disabled":"SelectSecondary_disabled__2n-fe"};